module.exports = __webpack_public_path__ + "media/fresh/FAFSA-calendar-7a6b6c20.svg";